import { baseApi, API_TAGS } from '@/shared/api';
import { createDashboardEndpointBuilder, type DashboardOptions, type ServiceUsersResponse } from '@/entities/dashboard';

const serviceUsersEndpoint = createDashboardEndpointBuilder('/service-users');

export const serviceUsersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getServiceUsers: builder.query<ServiceUsersResponse, DashboardOptions | undefined>({
      query: (options) => ({
        url: serviceUsersEndpoint(''),
        params: options
      }),
      providesTags: [API_TAGS.DASHBOARD, API_TAGS.SERVICE_USERS]
    })
  })
});

export const { useGetServiceUsersQuery } = serviceUsersApi;
